import { render, staticRenderFns } from "./tenant_manager.vue?vue&type=template&id=b0811bd4&scoped=true&"
import script from "./tenant_manager.vue?vue&type=script&lang=js&"
export * from "./tenant_manager.vue?vue&type=script&lang=js&"
import style0 from "./tenant_manager.vue?vue&type=style&index=0&id=b0811bd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0811bd4",
  null
  
)

export default component.exports